export default {
  SOFTWARE: { value: 0, title: "Програмний продукт" },
  LICENSE: { value: 1, title: "Ліцензія" },
  OTHER: { value: 2, title: "Інше" },
};